export const FETCH_REMOTE_CONFIGURATION_REQUEST = 'REMOTE_CONFIGURATION_REQUEST';
export const FETCH_REMOTE_CONFIGURATION_SUCCESS = 'REMOTE_CONFIGURATION_SUCCESS';
export const FETCH_REMOTE_CONFIGURATION_FAIL = 'REMOTE_CONFIGURATION_FAIL';
